import React, {useEffect} from "react";
import {Spin} from 'antd';
import api from "../../../services/api";

import './style.scss';
import CircularProgress from "./CircularProgress";

const ApiSpinner  = ({children}: {children: React.ReactElement}) => {
    const [counter, setCounter] = React.useState(0)

    useEffect(()=> {
        api.interceptors.request.use(
            (config) => {
                setCounter(r => r + 1)
                return config
            },
            (error) => {
                return Promise.reject(error)
            }
        )

        api.interceptors.response.use((response) => {
                setCounter(r => r - 1)
                return response
            },
            (error) => {
                setCounter(r => r - 1)
                return Promise.reject(error)
            }
        )
    }, [])

    return (
        <Spin spinning={counter > 0} indicator={<CircularProgress/>} wrapperClassName='mino-api-sinner' >
            {children}
        </Spin>
    )
}

export default ApiSpinner;